import React, { Component, memo } from 'react';
import DevicesPageTabsBar from './DevicesPageTabsBar/DevicesPageTabsBar';
import './DevicesPage.css';
import ParametersView from 'components/features/ParametersView/ParametersView';
import DeviceView from 'components/features/DeviceView/DeviceView';
import FiltersBar from 'components/features/FiltersBar/FiltersBar';
import BulkSoftwareDownloadModal from 'components/features/SoftwareDownloadModal/BulkSoftwareDownloadModal/BulkSoftwareDownloadModal';
import BulkCreateDevicesListModal from 'components/features/CreateDevicesListModal/CreateDevicesListModal';
import BulkManageDevicesListsModal from 'components/features/ManageDevicesListsModal/ManageDevicesListsModal';
import ViewDevicesListModal from 'components/features/ViewDevicesListModal/ViewDevicesListModal';
import ActionDetailsModal from 'components/features/Actions/ActionDetailsModal/ActionDetailsModal';
import {
  setPage,
  updateTabInitialRequest,
  updateDevicesPageActiveTab,
  updateDevicesPageBulkActionModal,
  updateDevicesPageBulkCreateListModal,
  bulkUpdateSoftware,
  clearSelectedDevicesList,
  setMapSelectMode,
  updateDevicesPageSelectedDeviceId,
  updateDevicesPageExpandedBundleId,
  clearSelectedDevicesData,
  updateDevicesPageBulkManageListsModal,
  updateDevicesPageManageColumnsModal,
  updateDevicesPageViewDevicesListModal,
  updateDevicesPageSwUpdateStatusModal,
  clearToastNotifications,
  addToastNotification,
  propagateFilters,
  doGetAllUserDevicePolygons,
  setDefaultActivePolygon,
  setDeviceTableWidth,
  updateSingleDevicePageSelectedDevice
} from 'redux/actions';
import { isObjectEmpty } from 'common/utils/helpers';
import { getParsedFilterSet } from 'components/features/FiltersBar/utils';
import { Status, DEVICES_PAGE_TAB, USER_PREFERENCE_SETS } from 'common/utils/constants';
import { connect } from 'react-redux';
import Modal from 'components/shared/Modal/Modal';
import { v4 } from 'uuid';
import { getBulkSoftwareDetails } from 'apis/GetBulkSoftwareDetails';
import ManageColumnsModal from 'components/features/ManageColumnsModal/ManageColumnsModal';
import ToastNotificationActionTypes from 'components/shared/ToastNotifications/constants';
import { selectUserPreferences } from '../../redux/selectors';
import { memoOnce, selectUserPreference, selectUserPreferenceList } from '../../redux/UserPreferences';

class DevicesPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showActionErrorModal: false,
      actionResult: null,
      filterSetActionPending: false,
      actionPending: false,
      localSelectedDeviceGroupName: '',
      swUpdateAction: null,
      swUpdateActionId: null,
      pivotInitialRequestsSent: false,
      echoInitialRequestsSent: false,
      allDevicesInitialRequestsSent: false
    };

    this.closeActionErrorModal = this.closeActionErrorModal.bind(this);
  }

  componentDidMount() {
    const {
      props: { dispatch, bulkActionModalOpen }
    } = this;

    dispatch(setPage('DevicesPage'));
    dispatch(updateSingleDevicePageSelectedDevice(null));
    bulkActionModalOpen && dispatch(updateDevicesPageBulkActionModal(false));

    // uncomment out below only if we will have the console page to fetch devices data,
    // if so, we should uncomment out the _search API calling on console page
    //isObjectEmpty(originalDevices) && dispatch(searchFilteredDevices());

    // uncomment below if we want to re-fetch the most updated filtered devices when user returns to devices page
    // if (!isObjectEmpty(filterBody)) {
    //   dispatch(searchFilteredDevices(filterBody))
    // }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.swUpdateStatusModalOpen &&
      this.state.swUpdateAction?.instance_id &&
      isObjectEmpty(this.state.swUpdateAction.devices)
    ) {
      getBulkSoftwareDetails(this.state.swUpdateAction.instance_id)
        .then((result) => {
          if (result.devices && !isObjectEmpty(result.devices)) {
            this.setState({ swUpdateAction: result });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }

    // send out request for initial load
    const activeTab = this.props.activeTab;
    // if (
    //   !this.props.initialRequestSent &&
    //   this.defaultFilterSetReady(this.props) &&
    //   this.defaultDeviceListReady(this.props)
    // ) {
    //   updateTabInitialRequest(activeTab);
    //   console.log('getting initial data', activeTab, this.props.initialRequestSent);
    //   // this.getInitialData();
    // }
    if (activeTab === DEVICES_PAGE_TAB.pivot) {
      if (
        !this.props.initialRequestSent &&
        !this.state.pivotInitialRequestsSent &&
        this.defaultFilterSetReady(this.props) &&
        this.defaultDeviceListReady(this.props)
      ) {
        this.setState({ pivotInitialRequestsSent: true }, () => {
          this.getInitialData();
          this.props.dispatch(updateTabInitialRequest(activeTab));
        });
      }
    } else if (activeTab === DEVICES_PAGE_TAB.echo) {
      if (
        !this.props.initialRequestSent &&
        !this.state.echoInitialRequestsSent &&
        this.defaultFilterSetReady(this.props) &&
        this.defaultDeviceListReady(this.props)
      ) {
        this.setState({ echoInitialRequestsSent: true }, () => {
          this.getInitialData();
          this.props.dispatch(updateTabInitialRequest(activeTab));
        });
      }
    } else {
      if (
        !this.props.initialRequestSent &&
        !this.state.allDevicesInitialRequestsSent &&
        this.defaultFilterSetReady(this.props) &&
        this.defaultDeviceListReady(this.props)
      ) {
        this.setState({ allDevicesInitialRequestsSent: true }, () => {
          this.getInitialData();
          this.props.dispatch(updateTabInitialRequest(activeTab));
        });
      }
    }

    const deviceTableDiv = document.getElementsByClassName('DeviceTable')?.[0];
    const deviceTableWidth = deviceTableDiv && deviceTableDiv.clientWidth;

    if (deviceTableDiv && deviceTableWidth !== null && this.props.deviceTableWidth !== prevProps.deviceTableDiv) {
      this.props.dispatch(setDeviceTableWidth(deviceTableWidth));
    }
  }

  componentWillUnmount() {
    this.props.dispatch(clearToastNotifications());
  }

  getInitialData = () => {
    this.props.dispatch(
      doGetAllUserDevicePolygons((result) => {
        const defaultPolygon = result.find((polygon) => polygon.properties.default);
        const defaultPolygonId = defaultPolygon ? defaultPolygon.deviceGroupId : null;
        const isDefaultPolygonInitialised = Boolean(defaultPolygonId);

        this.props.dispatch(setDefaultActivePolygon(defaultPolygonId, isDefaultPolygonInitialised)).then(() => {
          const activeFilterSet = this.props.activeFilterSet ?? {};
          const activeDeviceGroupIds = this.getActiveDeviceGroupIds(this.props);
          let filters = {
            ...this.props.filterBody
          };

          if (Object.keys(activeFilterSet).length !== 0)
            filters = {
              ...filters,
              ...getParsedFilterSet(activeFilterSet.state)
            };

          if (activeDeviceGroupIds.length !== 0)
            filters = {
              ...filters,
              deviceId: activeDeviceGroupIds
            };

          this.props.dispatch(propagateFilters(this.props.activeTab, filters));
        });
      })
    );
  };

  getActiveDeviceGroupIds = (props) => {
    if (!props.deviceGroups || !props.selectedDeviceGroupName) return [];
    return props.deviceGroups[props.selectedDeviceGroupName]?.devices || [];
  };

  defaultFilterSetReady = (props) => props.activeFilterSetId !== undefined;

  defaultDeviceListReady = (props) => props.selectedDeviceGroupName !== undefined;

  closeActionErrorModal() {
    this.setState({ showActionErrorModal: false });
  }

  handleAfterModalClose = () => {
    this.props.dispatch(clearSelectedDevicesList(this.props.activeTab));
    this.props.dispatch(setMapSelectMode({ bulk: false, allSelect: false }));
    this.props.dispatch(clearSelectedDevicesData(this.props.activeTab));
  };

  areSearchCallsPending = () => {
    const { deviceTableStatus, deviceMapStatus, parameterTableStatus, parameterGraphStatus } = this.props;
    let loading = false;
    if (
      deviceTableStatus === Status.PENDING ||
      deviceMapStatus === Status.PENDING ||
      parameterTableStatus === Status.PENDING ||
      parameterGraphStatus === Status.PENDING
    ) {
      loading = true;
    }

    return loading;
  };

  tabOnClick = (tab) => {
    if (tab === this.props.activeTab) return;
    this.props.dispatch(updateDevicesPageActiveTab(tab));
    this.props.dispatch(updateDevicesPageSelectedDeviceId(''));
    this.props.dispatch(updateDevicesPageExpandedBundleId(''));
  };

  handleSelectDeviceGroup = ({ name }) => {
    this.setState({ localSelectedDeviceGroupName: name });
  };

  render() {
    const {
      bulkActionModalOpen,
      bulkCreateDevicesListModalOpen,
      bulkManageDevicesListsModalOpen,
      manageDevicesTableColumnsModalOpen,
      swUpdateStatusModalOpen,
      viewDevicesListModalOpen,
      selectedDevicesDictionary,
      bundles,
      dispatch,
      softwareVersions
    } = this.props;
    let selectedDeviceIds = [];
    let fetching = this.areSearchCallsPending();
    // let overlay = fetching ? <div className="DevicesPage_LoadingCircle_Overlay">{LOADING_CIRCLE}</div> : null;

    if (bulkActionModalOpen || bulkCreateDevicesListModalOpen) {
      Object.keys(selectedDevicesDictionary).forEach((id) => {
        if (selectedDevicesDictionary[id] === true) {
          selectedDeviceIds.push(id);
        }
      });
    }

    let selectedAction = this.state.swUpdateAction;
    if (this.state.swUpdateActionId != null) {
      if (this.props.actionsList?.active?.[this.state.swUpdateActionId]) {
        selectedAction = this.props.actionsList.active[this.state.swUpdateActionId];
      }
    }

    let swUpdateStatusModal = null;

    if (swUpdateStatusModalOpen && selectedAction != null) {
      swUpdateStatusModal = (
        <ActionDetailsModal
          actionType={'BulkSoftwareUpdate'}
          action={selectedAction}
          actionTableType={'active'}
          setDetailsModalOpen={(isOpen) => this.props.dispatch(updateDevicesPageSwUpdateStatusModal(isOpen))}
        />
      );
    }

    let actionErrorModal;
    if (this.state.showActionErrorModal) {
      let actionResult = this.state.actionResult;
      let height = 200;

      actionErrorModal = (
        <Modal
          closeTargetRef={null}
          close={() => {
            this.closeActionErrorModal();
          }}
          animate={false}
          animateX={false}
          opaque={true}
          height={height}
          width={340}
          zIndex={2}
        >
          <div className="DevicePage_ActionErrorModal">
            {actionResult.success === false && (
              <div className="DevicePage_ActionErrorModal_Fail">
                <div className="DevicePage_ActionErrorModal_Fail_Title">Error</div>
                <div className="DevicePage_ActionErrorModal_Fail_Message">{actionResult.message.toString()}</div>
              </div>
            )}
            <div className="DevicePage_ActionErrorModal_Button_Div">
              <button
                className="Global_ThinBlueButton DevicePage_ActionErrorModal_Button"
                onClick={this.closeActionErrorModal}
              >
                OK
              </button>
            </div>
          </div>
        </Modal>
      );
    }

    let actionSelectedDevicesDictionary = {};
    Object.entries(selectedDevicesDictionary)
      .filter(([, v]) => v === true)
      .forEach(([k, v]) => (actionSelectedDevicesDictionary[k] = v));

    let bulkActionModal = null;
    let bulkCreateListModal = null;
    let bulkManageListsModal = null;
    let manageColumnsModal = null;
    let viewDevicesListModal = null;

    if (viewDevicesListModalOpen) {
      viewDevicesListModal = (
        <ViewDevicesListModal
          localSelectedDeviceGroupName={this.state.localSelectedDeviceGroupName}
          animateModalClose={false} //this determines whether closing modal performs animation
          closeModal={false}
          afterModalClose={() => {
            dispatch(updateDevicesPageViewDevicesListModal(false));
            this.handleAfterModalClose();
          }}
        />
      );
    }

    if (bulkManageDevicesListsModalOpen) {
      bulkManageListsModal = (
        <BulkManageDevicesListsModal
          animateModalClose={false} //this determines whether closing modal performs animation
          closeModal={false}
          afterModalClose={() => {
            dispatch(updateDevicesPageBulkManageListsModal(false));
            this.handleAfterModalClose();
          }}
        />
      );
    }

    if (manageDevicesTableColumnsModalOpen) {
      manageColumnsModal = (
        <ManageColumnsModal
          activeTab={this.props.activeTab}
          columnsPreferences={this.props.columnsPreferences}
          animateModalClose={false} //this determines whether closing modal performs animation
          closeModal={false}
          afterModalClose={() => {
            dispatch(updateDevicesPageManageColumnsModal(false));
            this.handleAfterModalClose();
          }}
        />
      );
    }

    if (bulkActionModalOpen) {
      bulkActionModal = (
        <BulkSoftwareDownloadModal
          key={0}
          cancelOnClick={() => {
            dispatch(updateDevicesPageBulkActionModal(false));
            dispatch(clearSelectedDevicesList(this.props.activeTab));
            dispatch(setMapSelectMode({ bulk: false, allSelect: false }));
            dispatch(updateDevicesPageSelectedDeviceId(null));
          }} //this runs when the cancel button is clicked. Used to update store that modal has closed
          animateModalClose={false} //this determines whether closing modal performs animation
          selectedDevicesDictionary={actionSelectedDevicesDictionary}
          deviceIdList={selectedDeviceIds}
          bundles={bundles}
          //  deviceDataList={selectedDevicesData}
          afterModalClose={() => {
            dispatch(updateDevicesPageBulkActionModal(false));
            this.handleAfterModalClose();
          }}
          closeModal={false} //no external modal closing, this is only necessary if there is an animation that needs to happen before hiding the modal
          initiateBulkSwUpgrade={(sentSelectedDeviceIds, swId, transferDate, activationDate) => {
            /* dispatch bulk update, use callbacks to then update state of actions status */
            this.setState({ actionPending: true });
            dispatch(
              bulkUpdateSoftware(
                sentSelectedDeviceIds,
                swId,
                transferDate,
                activationDate,
                (result) => {
                  dispatch(updateDevicesPageBulkActionModal(false));
                  dispatch(clearSelectedDevicesList(this.props.activeTab));
                  this.setState({
                    actionPending: false,
                    actionResult: { success: true },
                    swUpdateAction: result,
                    swUpdateActionId: result.instance_id
                  });
                  dispatch(updateDevicesPageBulkCreateListModal(false));
                  dispatch(
                    addToastNotification({
                      id: v4(),
                      title: '',
                      description: 'The SW update is scheduled',
                      actionType: ToastNotificationActionTypes.VIEW_SW_UPDATE_PROGRESS,
                      actionMessage: 'View progress',
                      reverse: true,
                      callback: (isOpen) => {
                        dispatch(updateDevicesPageSwUpdateStatusModal(isOpen));
                      }
                    })
                  );
                }, //, date:datetime}})},
                (error) => {
                  this.setState({
                    showActionErrorModal: true,
                    actionPending: false,
                    actionResult: { success: false, message: error }
                  });
                }
              )
            );
            dispatch(setMapSelectMode({ bulk: false, allSelect: false }));
            dispatch(updateDevicesPageSelectedDeviceId(null));
            dispatch(clearSelectedDevicesData(this.props.activeTab));
          }}
          softwareVersions={softwareVersions}
          actionPending={this.state.actionPending}
          processError={(error) => {
            this.setState({
              showActionErrorModal: true,
              actionPending: false,
              actionResult: { success: false, message: error }
            });
            dispatch(clearSelectedDevicesData(this.props.activeTab));
          }}
        />
      );
    }

    if (bulkCreateDevicesListModalOpen) {
      bulkCreateListModal = (
        <BulkCreateDevicesListModal
          handleSave={() => {
            dispatch(updateDevicesPageBulkCreateListModal(false));
          }}
          selectedDevicesDictionary={actionSelectedDevicesDictionary}
          deviceIdList={selectedDeviceIds}
          afterModalClose={() => {
            dispatch(updateDevicesPageBulkCreateListModal(false));
            this.handleAfterModalClose();
          }}
        />
      );
    }
    return (
      <div className="DevicesPageContainer">
        {actionErrorModal}
        {bulkActionModal}
        {bulkCreateListModal}
        {bulkManageListsModal}
        {manageColumnsModal}
        {viewDevicesListModal}
        {swUpdateStatusModal}
        <DevicesPageTabsBar activeTab={this.props.activeTab} tabOnClick={this.tabOnClick} />
        {/* <ConsoleTitleBar title="Devices" /> */}
        <FiltersBar fetching={fetching} />
        <DeviceView onSelectDeviceGroup={this.handleSelectDeviceGroup} />
        <ParametersView />
      </div>
    );
  }
}
const selectPreferenceList = memoOnce(selectUserPreferenceList);

export default connect((store) => {
  let filterBody;
  let selectedDevicesDictionary;
  let initialRequestSent;

  const activeTab = store.ui.devicesPage.activeTab;
  if (activeTab === DEVICES_PAGE_TAB.pivot) {
    filterBody = store.data.pivotFilterDictionary;
    selectedDevicesDictionary = store.ui.devicesPage.pivotTab.selectedDevicesDictionary;
    initialRequestSent = store.data.pivotDeviceSets.initialRequestSent;
  } else if (activeTab === DEVICES_PAGE_TAB.echo) {
    filterBody = store.data.echoFilterDictionary;
    selectedDevicesDictionary = store.ui.devicesPage.echoTab.selectedDevicesDictionary;
    initialRequestSent = store.data.echoDeviceSets.initialRequestSent;
  } else {
    filterBody = store.data.allDevicesFilterDictionary;
    selectedDevicesDictionary = store.ui.devicesPage.allDevicesTab.selectedDevicesDictionary;
    initialRequestSent = store.data.allDeviceSets.initialRequestSent;
  }

  const activeFilterSetId = store.ui.devicesPage.activeFilterSetId;
  const userPreferences = selectUserPreferences(store);
  const activeFilterSet = selectUserPreference(userPreferences, activeFilterSetId);
  const columnsPreferences = selectPreferenceList(userPreferences, USER_PREFERENCE_SETS.COLUMNS_SET);

  return {
    activeTab,
    filterBody,
    initialRequestSent,
    columnsPreferences,
    bulkActionModalOpen: store.ui.devicesPage.bulkActionModalOpen,
    createSiteModalOpen: store.ui.devicesPage.createSiteModalOpen,
    bulkCreateDevicesListModalOpen: store.ui.devicesPage.bulkCreateDevicesListModalOpen,
    bulkManageDevicesListsModalOpen: store.ui.devicesPage.bulkManageDevicesListsModalOpen,
    manageDevicesTableColumnsModalOpen: store.ui.devicesPage.manageDevicesTableColumnsModalOpen,
    viewDevicesListModalOpen: store.ui.devicesPage.viewDevicesListModalOpen,
    swUpdateStatusModalOpen: store.ui.devicesPage.swUpdateStatusModalOpen,
    deviceGroups: store.ui.devicesPage.deviceGroups,
    activeFilterSet,
    activeFilterSetId,
    selectedDeviceGroupName: store.ui.devicesPage.selectedDeviceGroupName,
    toastNotifications: store.ui.sharedPages.toastNotifications,
    selectedDevicesDictionary,
    softwareVersions: store.data.softwareVersions,
    bundles: store.data.bundlesStorage.storedBundlesDictionary,
    actionsList: store.data.actionsList,
    deviceTableStatus: store.statuses['searchComponentFilteredDevicesV2_deviceTable_' + activeTab],
    deviceMapStatus: store.statuses['searchComponentFilteredDevicesV2_deviceMap_' + activeTab],
    parameterTableStatus: store.statuses['searchComponentFilteredDevicesV2_parametersTable_' + activeTab],
    parameterGraphStatus: store.statuses['searchComponentFilteredDevicesV2_parametersGraph_' + activeTab],
    deviceTableWidth: store.ui.devicesPage.deviceTableWidth
  };
})(memo(DevicesPage));
